import { Component, OnInit } from '@angular/core';
import { LanguageService } from '../../core/language/language.service';
import { ToastService } from '../../core/toast/toast.service';
import { ModalService } from '../../core/modal/modal.service';
import { SharedService } from '../../shared/shared.service';
import { DropdownItem } from '../../core/models/dropdown-item';
import { ComplaintsService } from '../complaints.service';
import { ComplaintList } from '../../core/models/administration/complaint-configuration/complaint-list';
import { SearchComplaints } from '../../core/models/complaint/search-complaints-list';

@Component({
  selector: 'app-my-complaint',
  templateUrl: './my-complaint.component.html',
  styleUrls: ['./my-complaint.component.css']
})
export class MyComplaintComponent implements OnInit {
    public items: ComplaintList[];
    public categories: DropdownItem[] = [];
    public statuses: DropdownItem[] = [];
    public searchModel: SearchComplaints;
    private languageID: number;
    public pathname: string;

    public offset: number = 0;
    public limit: number = 10;
    public size: number = 0;
    public pageNum: number = 1;
    public pageSize: number = this.limit;

    public isDesc: boolean = true;
    public column: string = "";

    constructor(private _complaintsService: ComplaintsService,
        private _sharedService: SharedService,
        private _languageService: LanguageService,
        private _toastService: ToastService,
        private _modalService: ModalService) {
        this.items = [];
        this.searchModel = new SearchComplaints();
        this.languageID = this._languageService.selectedLanguageId;
        this.searchModel.languageId = this.languageID;
        this._sharedService.getAllCategoriesForDropdown(0, true, this.languageID).subscribe(result => {
            this.categories = result;
        });
        this._sharedService.getAllComplaintStatusesForDropdown(0, true, this.languageID).subscribe(result => {
            this.statuses = result;
        });
    }

    ngOnInit() {
        this.pathname = location.pathname;
        this.initSearchModel();
        this.getAll();
    }

    getAll() {
        this.searchModel.pageNumber = this.pageNum;
        this.searchModel.pageSize = this.pageSize;
        this._complaintsService.searchComplaintsByUserID(this.searchModel).subscribe(result => {
            this.items = result.results;
            this.size = result.rowCount;
        });
       
    }

    initSearchModel() {
        this.searchModel.languageId = this.languageID;
        this.searchModel.pageNumber = 1;
        this.searchModel.pageSize = 10;
        this.searchModel.title = null;
        this.searchModel.categoryId = 0;
        this.searchModel.statusId = 0;
        this.searchModel.column = "";
        this.searchModel.isDesc = this.isDesc;
    }

    search() {
        this.searchModel.pageNumber = 1;
        this.searchModel.pageSize = this.pageSize;
        this._complaintsService.searchComplaintsByUserID(this.searchModel).subscribe(result => {
            this.items = result.results;
            this.size = result.rowCount;
        });
    }

    clearSearch() {
        this.initSearchModel();
        this.getAll();
    }

    onLimitChange(newLimit: number) {
        this.offset = 0;
        this.limit = newLimit;
        this.pageNum = 1;
        this.pageSize = newLimit;
        this.getAll();
    }

    onPageChange(offset: number) {
        this.offset = offset;
        this.pageNum = Math.floor(offset / this.limit) + 1;
        this.getAll();
    }

    sort(column: string) {
        // za font awesome
        this.column = column;
        this.isDesc = !this.isDesc;
        // za query
        this.searchModel.column = column;
        this.searchModel.isDesc = !this.searchModel.isDesc;
        this._complaintsService.searchComplaintsByUserID(this.searchModel).subscribe(result => {
            this.items = result.results;
            this.size = result.rowCount;
        });
    }
    downloadPDF() {
        const pdfUrl = "../../../assets/documents/instructions/prituzbe.pdf";
        const pdfName = 'korisnicke_upute_prituzbe.pdf';

        const link = document.createElement('a');
        link.href = pdfUrl;
        link.download = pdfName;
        link.click();
    }
}
